import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';

class HistoryBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { historyTopic, historyTitle, historyList0, historyList1 },
        } = this.props;

        return (
            <div id="historyNewsList" className={styles.history_box}>
                <Chip id="50071" type="struct" title="军事历史栏标题" groupName="军事历史栏" content={historyTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75069"
                    type="recommend"
                    title="军事历史栏头条"
                    groupName="军事历史栏"
                    content={historyTitle}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75071"
                    type="recommend"
                    title="军事历史栏新闻列表1"
                    groupName="军事历史栏"
                    content={historyList0}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75072"
                    type="recommend"
                    title="军事历史栏新闻列表2"
                    groupName="军事历史栏"
                    content={historyList1}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(HistoryBox);
